import { FC, useEffect, useState } from 'react'
import { MenuVariant } from '../app/types/catalog-types'
import { urls } from '../navigation'
import { Link } from 'react-router-dom'
import { useAppSelector } from '../app/hooks'
import { langSelector, useURLLang } from '../app/main-slice'
import styles from './choose-variant.module.css'
import { useMessages2 } from '../hooks/useLanguage'
import { ButtonBar } from '../controls/buttons'
import ChooseHeader from '../controls/chooseHeader/choose-header'
import { useEnvConfig } from '../app/context/environment-context'

export type ChooseVariantProps = {
    categoryId: string
    familyId: string
    variants: MenuVariant
}

export const ChooseVariant: FC<ChooseVariantProps> = ({ categoryId, familyId, variants }) => {  

    const lang = useURLLang();
    const { messages } = useMessages2();
    const [ imgURLs, setImgURLs ] = useState<string[]>([]);
    const { thumbnailsPath } = useEnvConfig();

    useEffect(() => {
        const urls = variants.options.map(option => `${thumbnailsPath}/variants/${option.image}.png`);
        setImgURLs(urls);
      }, []); 


    const handleMouseOver = ( index: number) => {
        const newImgs = imgURLs.slice();
        newImgs[index] = newImgs[index].replace("png","gif");
        setImgURLs(newImgs)
    }    
    
    const handleMouseOut = ( index: number) => {
        const newImgs = imgURLs.slice();
        newImgs[index] = newImgs[index].replace("gif","png");
        setImgURLs(newImgs)
    }  

   
    return <>
        <ChooseHeader 
            title={ messages?.monomulti_question1  || ""} 
            urlBack={urls.category(lang, categoryId)}
        />


        <ul className={styles.variantContainer}>
            {
                variants.options.map((option, index) => (
                    <li className={styles.variantBox} key={option.id}>
                        <h3 className={styles.optionTitle}>{option.title}</h3> 
                        <img 
                            className={styles.optionImg}
                            src={imgURLs[index]} 
                            onMouseOver={() => handleMouseOver(index)}
                            onMouseOut={() => handleMouseOut(index)}>
                        </img>
                        
                        <ButtonBar>
                            <Link to={urls.variantCfg(lang, categoryId, familyId, option.id)}>
                                <button className={styles.optionButton}>
                                    {messages?.monomulti_monomove_title}
                                </button>
                            </Link>
                        </ButtonBar>
                            
                        {option.image === "mono-move-start" && 
                            <ul className={styles.variantText}>
                                <li>{messages?.monomulti_monomove_description1}</li>
                                <li>{messages?.monomulti_monomove_description2}</li>
                            </ul>
                        }
                        {option.image === "multi-move-start" && 
                            <ul className={styles.variantText}>
                                <li>{messages?.monomulti_multimove_description1}</li>
                                <li>{messages?.monomulti_multimove_description2}</li>
                            </ul>
                        }
                    </li>
                )
            )}
        </ul>
    </>
}